import { isValidISODate } from "@/lib/dates";
import type { EffectiveQuotation } from "./types";

export type DashboardQuotationLink =
  | { date: string; quotationId: string; storeId: string; clientId?: never }
  | { date: string; quotationId: string; clientId: string; storeId?: never };

export function resolveDashboardQuotationLink(
  link: DashboardQuotationLink,
  publications: readonly { id: string; date: string; status: string }[],
  authority: { clientId: string; stores: readonly { id: string }[] },
  effective:
    | Pick<
        EffectiveQuotation,
        | "id"
        | "date"
        | "status"
        | "is_special"
        | "parent_quotation_id"
        | "applied_target_type"
        | "targets"
      >
    | undefined,
  effectiveItemsId: string | undefined,
): DashboardQuotationLink | null {
  const scopeValid = link.storeId
    ? authority.stores.some(({ id }) => id === link.storeId)
    : link.clientId === authority.clientId;
  const targetId =
    effective?.applied_target_type === "store"
      ? link.storeId
      : authority.clientId;
  const specialValid = effective?.is_special
    ? effective.parent_quotation_id === link.quotationId &&
      (effective.applied_target_type === "customer" ||
        (effective.applied_target_type === "store" && Boolean(link.storeId))) &&
      (!effective.targets ||
        effective.targets.some(
          ({ target_type, target_id }) =>
            target_type === effective.applied_target_type &&
            target_id === targetId,
        ))
    : effective?.id === link.quotationId;
  if (
    !isValidISODate(link.date) ||
    !scopeValid ||
    !publications.some(
      ({ id, date, status }) =>
        id === link.quotationId &&
        date.slice(0, 10) === link.date &&
        status === "completed",
    ) ||
    !effective ||
    effective.date.slice(0, 10) !== link.date ||
    effective.status !== "completed" ||
    effective.id !== effectiveItemsId ||
    !specialValid
  )
    return null;
  return link;
}
